const ENTITY_TYPE_MAP: Record<string, string> = {
  "autohighlight": "autohighlight",
  "clip": "user_highlight",
  "player-highlight": "athlete_highlight",
  "event": "event",
};

export function formatEntityType(type: string) {
  return ENTITY_TYPE_MAP[type] || type;
}
